import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from "@apollo/client";
import React from "react";
import { UPDATE_COMMENT_REPLY } from "../../apollo/operations";
import { CommentReplyInput } from "..";

type CommentReplyContentProps = {
  index: number;
  id: string;
  createdAt: string;
  content: string;
  userID: string | null;
  refetch: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<any>>;
  openEdit: number | null;
  onChange: boolean;
  setOnChange: React.Dispatch<React.SetStateAction<boolean>>;
  textArea: React.MutableRefObject<HTMLTextAreaElement | null>;
  setOpenEdit: (value: React.SetStateAction<number | null>) => void;
  commentId?: string;
};
const CommentReplyContent: React.FC<CommentReplyContentProps> = ({
  index,
  id,
  createdAt,
  content,
  userID,
  refetch,
  openEdit,
  onChange,
  setOnChange,
  textArea,
  setOpenEdit,
  commentId,
}) => {
  const maxLength = 200;
  const [updateComment, setUpdateComment] = React.useState(content);
  const [isExpanded, setIsExpanded] = React.useState(false);

  const [updateReply, { loading: loadUpdate }] = useMutation(
    UPDATE_COMMENT_REPLY,
    {
      // onCompleted: () => {
      //   refetch();
      // },
      onError(err) {
        console.log(err);
        const _error = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(_error);
      },
    }
  );

  const handleUpdateReply = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateReply({
      variables: {
        data: {
          comment: {
            id: commentId,
          },
          commentBy: {
            id: userID,
          },
          message: updateComment,
        },
        where: {
          id: id,
        },
      },
      onCompleted() {
        refetch();
        setOpenEdit(null);
      },
    });
  };

  return (
    <>
      {openEdit !== index ? (
        <div
          className="pr-5 pl-2 font-Rubik text-[10px] lg:text-sm font-normal w-full block whitespace-pre-line break-words text-justify text-[#646464]"
          key={index + id + createdAt}
        >
          {/* {content} */}
          {content && content.length <= maxLength
            ? content
            : isExpanded
            ? content
            : content?.slice(0, maxLength)}
          {content && content.length > maxLength && (
            <span
              className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? "... See more" : " ... See less"}
            </span>
          )}
        </div>
      ) : (
        openEdit === index && (
          <div className="w-full">
            <CommentReplyInput
              openEdit={openEdit}
              communityComment={updateComment}
              setCommunityComment={setUpdateComment}
              handleSubmit={handleUpdateReply}
              textArea={textArea}
              loading={loadUpdate}
              onChange={onChange}
              setOnChange={setOnChange}
              index={index}
            />
            {/* <button>cancel</button> */}
          </div>
        )
      )}
    </>
  );
};

export default CommentReplyContent;
